module.exports = __webpack_public_path__ + "static/bg@2x.c01cf27f.png";